import type { ReactNode } from 'react';

export const symbol_hail: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M167-110v-163q0-12.75 8.63-21.38Q184.25-303 197-303h44q12.75 0 21.38 8.62Q271-285.75 271-273v163q0 12.75-8.62 21.37Q253.75-80 241-80h-44q-12.75 0-21.37-8.63Q167-97.25 167-110Zm212 0v-485q-49 22-75.5 59T272-440q-1 11-10.5 17.5t-20.68 6.5q-11.93 0-20.87-8-8.95-8-7.95-20 9-109 80.36-168.5T482-672q100 0 157-34t66-119q2-13 10.68-22 8.67-9 21.5-9 12.82 0 21.32 8.5T766-827q-7 82-50.5 133T590-623v513q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q530-97.25 530-110v-225h-91v225q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q379-97.25 379-110Zm103.08-624q-30.08 0-51.58-21.42t-21.5-51.5q0-30.08 21.42-51.58t51.5-21.5q30.08 0 51.58 21.42t21.5 51.5q0 30.08-21.42 51.58t-51.5 21.5Z"
		/>
	</svg>
);
